import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import { createResponsiveStateReducer } from 'redux-responsive'
import environment from './environment';
import config from './config';
import i18n from './i18n';
import modellines from './modellines';
import trims from './trims';
import dma from './dma';
import userAmounts from './userAmounts';
import navigation from './navigation';
import bodyStyleFilter from './bodyStyleFilter';
import errors from './errors';
import bestOffers from './bestOffers';
import dealer from './dealer';
import leads from './leads';

const rootReducer = combineReducers({
  config,
  i18n,
  environment,
  routing,
  modellines,
  trims,
  dma,
  userAmounts,
  navigation,
  bodyStyleFilter,
  errors,
  bestOffers,
  dealer,
  leads,
  browser: createResponsiveStateReducer({
    small: 639,
    medium: 1023,
    large: 999999
  }),
});


export default rootReducer



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/index.js
 **/